import MetricsContainer from "./container";
import { MetricsContainer as MetricsContainerComponent } from "./component";

export { MetricsContainer, MetricsContainerComponent };
export default MetricsContainer;



// WEBPACK FOOTER //
// ./client/modules/Analytics/components/MetricsContainer/index.ts